<template>
    <div class="book-insight-background" :style="{ 'background-color' : color, 'background-image' : `url(${shape})` }">
        <slot name="content" />
    </div>
</template>

<script>
export default {
    name: "BookInsightBackground",
    props: {
        color: {
            type: String,
            required: true
        },
        shape: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss">
.book-insight-background {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: right bottom;
}
</style>
